module.exports = __webpack_public_path__ + "static/media/paredes_vivas_8.aa44caaa.jpg";